import React, { FC, MouseEventHandler } from 'react';
import classNames from 'classnames';
import { IUnitTestProps } from '@monorepo/client-types';
import { Flex } from '@monorepo/react-components';

import styles from './dashboard-card.module.scss';

interface DashboardCardProps extends IUnitTestProps {
  className?: string;
  children: React.ReactNode;
  vertical?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const DashboardCard: FC<DashboardCardProps> = ({
  className,
  children,
  vertical = true,
  onClick,
  testId,
}) => {
  return (
    <Flex
      data-testid={testId}
      vertical={vertical}
      className={classNames(styles.dashboardCard, className, {
        [styles.clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      {children}
    </Flex>
  );
};
export default DashboardCard;
